import { HouseReason, ReasonForm, Reason } from '@ha/domain';

import { Component, inject, input, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

import { ApDropdownComponent, DropdownOption } from '@ap/dropdown';
import { ApContentModule, ApContentService } from '@ap/content';
import { ErrorMessages } from '@ap/form/errors';
import { ApAnalyticsModule } from '@ap/analytics';
import { ApRadioButtonComponent, ApRadioGroupComponent } from '@ap/radio';

@Component({
    selector: 'reason',
    templateUrl: './reason.component.html',
    standalone: true,
    imports: [
        ApAnalyticsModule,
        ApContentModule,
        FormsModule,
        ReactiveFormsModule,
        ApRadioGroupComponent,
        ApDropdownComponent,
        ApRadioButtonComponent
    ]
})
export class ReasonComponent implements OnInit {
    private readonly contentService = inject(ApContentService);

    readonly reasonForm = input.required<FormGroup<ReasonForm>>();

    showHouseReasonDropdown = false;
    showRefinanceRadio = false;
    reasonOptions: DropdownOption[];
    houseReasonOptions: DropdownOption[];

    ngOnInit(): void {
        this.reasonOptions = this.getReasonOptions();
        this.houseReasonOptions = this.getHouseReasonOptions();
        this.subscribeToControls();
    }

    private subscribeToControls(): void {
        this.reasonForm().controls.reason?.valueChanges.subscribe((value: Reason) => {
            if (value !== null && (Reason.FIRST_HOUSE === value || Reason.NEXT_HOUSE === value)) {
                this.showHouseReasonDropdown = true;
                this.reasonForm().controls.houseReason?.setValidators(Validators.required);
            } else {
                this.showHouseReasonDropdown = false;
                this.reasonForm().controls.houseReason?.removeValidators(Validators.required);
            }

            if (value !== null && Reason.REFINANCE_MORTGAGE === value) {
                this.showRefinanceRadio = true;
                this.reasonForm().controls.refinance?.setValidators(Validators.required);
            } else {
                this.showRefinanceRadio = false;
                this.reasonForm().controls.refinance?.removeValidators(Validators.required);
            }
        });
    }

    private getReasonOptions(): DropdownOption[] {
        return Object.keys(Reason).map((reason: Reason) => {
            return {
                value: Reason[reason],
                label: this.contentService.get(`answer.label.${Reason[reason]}`)
            } as DropdownOption;
        });
    }

    private getHouseReasonOptions(): DropdownOption[] {
        return Object.keys(HouseReason).map((houseReason: HouseReason) => {
            return {
                value: HouseReason[houseReason],
                label: this.contentService.get(`answer.label.${HouseReason[houseReason]}`)
            } as DropdownOption;
        });
    }

    getErrorMessage(contentKey: string): ErrorMessages {
        const label: string = this.contentService.get(contentKey).toLowerCase();
        return {
            required: this.contentService.get('general.error.required', {
                fieldName: label
            })
        } as ErrorMessages;
    }
}
